import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function MaxGeneralId({
    setValue,
    getValues,
    clearErrors,
    errorlist,
    setErrorCreateTicket,
    defaultMaxGeneralId,
    disabled,
    numberGeneralIdLeft
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const corporationDetail = useRecoilValue(corporationAtom);
    const invalidCharsLimitValue = ['.', '-', '+', 'e', 'E', ',', '/'];

    const [maxGeneralId, setMaxGeneralId] = useState(defaultMaxGeneralId ? defaultMaxGeneralId : 1);

    let limitValue = corporationDetail?.limitValue;

    useEffect(() => {
        setValue('maxGeneralId', defaultMaxGeneralId ? defaultMaxGeneralId : 1);
    },[])

    const onChangeValue = e => {
        let value = e.target.value;
        const regex = /[^\p{Script=Latin}\p{N}]/u;
        if (regex.test(value)) {
            e.preventDefault();
        } else {
            // Xử lý giá trị nhập liệu hợp lệ
            setMaxGeneralId(parseInt(value));
        }
    };

    const onKeyDown = (event, invalidCharArr) => {
        if (Utils.isEmptyArray(invalidCharArr)) {
            return;
        }
        if (invalidCharArr.includes(event.key)) {
            event.preventDefault();
        }
    };

    const handleOnPaste = (event, invalidCharArr) => {
        if (Utils.isEmptyArray(invalidCharArr)) {
            return;
        }
        var value = event.clipboardData.getData('text');
        invalidCharArr?.forEach(item => {
            if (value.includes(item)) {
                event.preventDefault();
            }
        });
    };

    const onBlurValue = e => {
        let value = e.target.value;

        if (Utils.isEmptyString(value?.trim())) {
            return setErrorCreateTicket(
                'maxGeneralId',
                { type: 'manual', message: trI18n('COMMSG014') },
                { shouldFocus: true }
            );
        }

        if (value < Constant.INVITED_GENERAL_ID_RANGE.MIN && value) {
            clearErrors('maxGeneralId');
            setValue('maxGeneralId', Constant.INVITED_GENERAL_ID_RANGE.MIN);
            return setMaxGeneralId(Constant.INVITED_GENERAL_ID_RANGE.MIN);
        }

        setValue('maxGeneralId', parseInt(value.replace(/^0+/, '')));
        setMaxGeneralId(value.replace(/^0+/, ''));
        return clearErrors('maxGeneralId');
    };

    const getNumberGeneralIdLeft =  numberGeneralIdLeft ? numberGeneralIdLeft : limitValue?.maxNumOfGeneralUser - limitValue?.numOfGeneralUser

    return (
        <div className="form-addTicket">
            <div className="form-addTicket-label">
                {trLabel('利用可能なジェネラルユーザーID数')} ({tr('Max')}:{' '}
                {getNumberGeneralIdLeft})
                <span className="required">*</span>
            </div>
            <div className="form-addTicket-input">
                <TextField
                    name="maxGeneralId"
                    className="form-control-input form-control-wrapInput form-control-hg40 edit-max-general-id"
                    value={maxGeneralId}
                    variant="outlined"
                    type="number"
                    onChange={onChangeValue}
                    onKeyDown={e => onKeyDown(e, invalidCharsLimitValue)}
                    onPaste={e => handleOnPaste(e, invalidCharsLimitValue)}
                    onBlur={e => onBlurValue(e)}
                    helperText={errorlist['maxGeneralId']?.message}
                    error={!Utils.isEmptyObject(errorlist.maxGeneralId)}
                    onWheel={e => e.target.blur()}
                    disabled={disabled ? disabled : false}
                />
            </div>
        </div>
    );
}
